export default __webpack_public_path__ + "static/media/Nowe Logo z Tekstem.56c290c5.svg";